function parseCommaSeparatedValues(value?: string) {
  if (!value) {
    return []
  }

  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

function includesIgnoreCase(haystack: string, needle: string) {
  return haystack.toLowerCase().includes(needle.toLowerCase())
}

function normalizeSelection(values: string[]) {
  return values.map((item) => item.toLowerCase())
}

function courseMatchesAudience(course: CoursesRecord, selectedAudiences: string[]) {
  if (selectedAudiences.length === 0) {
    return true
  }

  const courseAudiences = parseCommaSeparatedValues(course.audience).map((item) =>
    item.toLowerCase()
  )
  return selectedAudiences.some((audience) => courseAudiences.includes(audience))
}

function courseMatchesLevel(course: CoursesRecord, selectedLevels: string[]) {
  return selectedLevels.length === 0 || (course.level && selectedLevels.includes(course.level))
}

function courseMatchesSearch(course: CoursesRecord, searchQuery: string) {
  return !searchQuery || includesIgnoreCase(course.title, searchQuery)
}

function getCourseLevelOptions(courses?: CoursesRecord[]) {
  const levels: string[] = []
  courses?.forEach((course) => {
    if (course.level && !levels.includes(course.level)) {
      levels.push(course.level)
    }
  })
  return levels
}

function getAudienceOptions(courses?: CoursesRecord[]) {
  const audienceOptions: string[] = []
  courses?.forEach((course) => {
    for (const audience of parseCommaSeparatedValues(course.audience)) {
      if (!audienceOptions.includes(audience)) {
        audienceOptions.push(audience)
      }
    }
  })
  return audienceOptions
}

function filterCourses(
  courses: CoursesRecord[] | undefined,
  searchQuery: string,
  selectedLevels: string[],
  selectedAudience: string[]
) {
  const selectedAudiences = normalizeSelection(selectedAudience)

  return (
    courses?.filter((course) => {
      return (
        courseMatchesSearch(course, searchQuery) &&
        courseMatchesLevel(course, selectedLevels) &&
        courseMatchesAudience(course, selectedAudiences)
      )
    }) || []
  )
}

export function useCourseDirectoryFilters() {
  return {
    getCourseLevelOptions,
    getAudienceOptions,
    filterCourses
  }
}
